import { useMutation, useQueryClient } from '@tanstack/react-query'

import { patch } from 'utils/http'

const prolongTrial = async ({ customerId, trialEnd }: any) => {
  const payload = {
    trial_end: trialEnd,
  }

  return patch(`/management/customers/${customerId}/plans/prolong_trial`, payload)
}

export const useProlongTrial = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: prolongTrial,
    onSuccess: async (_data, { customerId }: any) =>
      queryClient.invalidateQueries({ queryKey: ['customer', String(customerId)] }),
  })
}
